import { useMemo } from 'react';
import { getDuration, useMutation, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import PERMISSIONS from '@/common/permissions';
import { ValuesMap } from '@/common/types';
import { API_URL } from '@/dtos';
import { useHasAccess } from '@/modules/core';

interface PreferencesResponse {
  favourite_reports: string[];
  column_width: ValuesMap<number>;
}
export interface PreferencesResponseDTO {
  favoriteReports: string[];
  columnWidth: ValuesMap<number>;
}
export const useSaveReportPreferencesQuery = () => {
  //   const setReportKeys = useFavoriteReportsStore((state) => state.setReportKeys);
  const { mutateAsync, isLoading } = useMutation((values: PreferencesResponseDTO) =>
    api.post(API_URL.REPORTS_PREFERENCES, {
      favourite_reports: values.favoriteReports,
      column_width: values.columnWidth,
    })
  );

  return {
    isLoading,
    handleSave: mutateAsync,
  };
};

const QUERY_KEY = 'REPORT_PREFERENCES';

export const useGetReportPreferencesQuery = () => {
  const isHasPermission = useHasAccess([{ permission: PERMISSIONS.REPORTS }]);
  const { isLoading, data, isSuccess } = useQuery(
    [QUERY_KEY],
    // TODO: Missing type
    () => api.get<PreferencesResponse>(API_URL.REPORTS_PREFERENCES),
    {
      enabled: isHasPermission,
      gcTime: getDuration({ seconds: 10 }),
    }
  );
  const formattedData = useMemo(() => {
    const currentData = data?.data;
    return {
      favoriteReports: currentData?.favourite_reports || [],
      columnWidth: currentData?.column_width || {},
    };
  }, [data?.data]);

  return {
    isSuccess,
    data: formattedData,
    isLoading,
  };
};
